import React from 'react';
import styled from '@emotion/styled';
import { rem } from 'polished';
import { text, colors, spaces } from '../../../core/styles/theme/default';

const StyledErrorMessage = styled.div`
  ${text.l1};
  color: ${colors.primaryLightOrange700};
  margin-top: ${rem(spaces.alpha)};
`;

const ErrorMessage = ({ text, ...rest }: ErrorMessageProps) => {
  return <StyledErrorMessage {...rest}>{text}</StyledErrorMessage>;
};

export type ErrorMessageProps = {
  /** Text for Error Message */
  text: string;
};

export default ErrorMessage;
